export const MOVE_STATUS_TYPE = {
  pending: 0,
  loading: 1,
  inTransit: 2,
  unloading: 3,
  complete: 4
};

export const MOVE_STATUS_TYPE_ARR = [
  'pending',
  'loading',
  'inTransit',
  'unloading',
  'complete',
];

export const SORT_MOVES_BY_TYPE = {
  0: 'name',
  1: 'startDate',
  2: 'plannedDeliveryDate',
  3: 'moveStatus',
  4: 'origin',
  5: 'destination',
  6: 'device.name',
  7: 'transfereeName',
  8: 'relocationManagementCompany'
};

export const SORT_DESCENDING = {
  0: false,
  1: true,
};

export const MOVE_COLOR_BY_STATUS = {
  0: 'red lighten-1',
  1: 'orange lighten-1',
  2: 'amber lighten-2',
  3: 'blue lighten-1',
  4: 'green lighten-1'
};
